var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyAltWhite32X32 = function SvgCopyAltWhite32X32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.583 23.208h-7.166a2.687 2.687 0 0 1-2.687-2.687v-8.957a.9.9 0 0 0-1.791 0v8.957a4.478 4.478 0 0 0 4.478 4.478h7.165a.9.9 0 1 0 0-1.791Zm4.478-9.906a1.173 1.173 0 0 0-.054-.242v-.081a.958.958 0 0 0-.17-.251l-5.374-5.373a.958.958 0 0 0-.251-.17h-.081l-.286-.099h-3.636a2.687 2.687 0 0 0-2.687 2.687v8.957a2.687 2.687 0 0 0 2.687 2.686h7.165a2.687 2.687 0 0 0 2.687-2.687v-5.427Zm-5.374-3.162 2.32 2.32h-1.424a.9.9 0 0 1-.9-.9Zm3.583 8.589a.9.9 0 0 1-.9.9h-7.161a.9.9 0 0 1-.9-.9V9.773a.9.9 0 0 1 .9-.9h2.687v2.691a2.687 2.687 0 0 0 2.687 2.687h2.686Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20963",
    width: 32,
    height: 32,
    rx: 6,
    fill: "none",
    opacity: 0.5
  })));
};
export default SvgCopyAltWhite32X32;